<div class="navbar-wrapper" [ngClass]="{'container': this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'}">
  <app-nav-content (onNavMobCollapse)="navMobCollapse()"></app-nav-content>


</div>

